import React from 'react';
import { useAuth } from '../../firebase/AuthProvider';
import { LucideShieldAlert, LucideRefreshCcw } from 'lucide-react';

export const SandboxBanner: React.FC = () => {
    const { currentOrganization, currentOrganizationRoles, impersonatedUserId, currentUserInfo } = useAuth();

    const isSandbox = currentOrganization?.isSandbox;
    const isOwner = currentOrganizationRoles?.some(role => role.systemKey === 'ORG_OWNER');

    if (!isSandbox || (!isOwner && !impersonatedUserId)) return null;

    return (
        <div className={`w-full flex items-center justify-center gap-3 py-1 px-4 text-xs font-bold transition-colors ${
            impersonatedUserId 
            ? "bg-purple-600 text-white shadow-[0_2px_10px_rgba(147,51,234,0.3)]" 
            : "bg-amber-400 text-amber-900"
        }`}>
            {impersonatedUserId ? (
                <>
                    <LucideRefreshCcw size={14} className="animate-spin-slow" />
                    <span>Impersonating: {currentUserInfo?.displayName || `${currentUserInfo?.firstName} ${currentUserInfo?.lastName}`}</span>
                </>
            ) : (
                <>
                    <LucideShieldAlert size={14} />
                    <span>Sandbox Environment: Owner View</span>
                </>
            )}
        </div>
    );
};
